export const normalize = (s = '') => String(s).toLowerCase().trim();

export const findMatchingAttribute = (thumbnailImgs = [], shortLabel = '', longLabel = '') => {
  const sLabel = normalize(shortLabel || '');
  const lLabel = normalize(longLabel || sLabel || '');
  return (thumbnailImgs || []).find((attr) => {
    const val = normalize(attr.value || '');
    if (!val) return false;
    // Prioritize exact match
    if (val === sLabel || val === lLabel) return true;
    return false;
  });
};

export const findSwatchForChoice = (thumbnailImgs = [], choice = {}) => {
  const shortLabel = normalize(choice.shortLabel || '');
  const longLabel = normalize(choice.longLabel || shortLabel || '');
  if (!thumbnailImgs || thumbnailImgs.length === 0) return undefined;

  const found = findMatchingAttribute(thumbnailImgs, shortLabel, longLabel);
  return found ? found.swatchGuid : undefined;
};

export const findColorAttribute = (metaAttributes = []) => {
  if (!metaAttributes || !metaAttributes.length) return null;
  // First search for color/finish by attribute name
  const byName = metaAttributes.find((a) => /\bcolor(?:\/finish)?\b/i.test(a.attributeName || ''));
  if (byName) return byName;

  // Only if name lookup fails, search for THD media URLs in swatchGuid values
  const isThdMediaUrl = (s) => {
    if (!s || typeof s !== 'string') return false;
    return s.includes('images.thdstatic.com') || s.includes('swatchImages');
  };

  const bySwatchGuid = metaAttributes.find((a) => (a.attributeValues || []).some((v) => v && isThdMediaUrl(v.swatchGuid)));
  return bySwatchGuid || null;
};

export const getMediaUrlForChoice = (thumbnailImgs = [], choice = {}) => {
  const shortLabel = normalize(choice.shortLabel || '');
  const longLabel = normalize(choice.longLabel || shortLabel || '');

  if (!thumbnailImgs || thumbnailImgs.length === 0) return choice.mediaUrl;
  const found = findMatchingAttribute(thumbnailImgs, shortLabel, longLabel);
  return found ? found.swatchGuid : choice.mediaUrl;
};

export const choiceHasPriceForChoice = (choicesWithPrices = [], choice = {}) => (
  choicesWithPrices && choicesWithPrices.some((ch) => ch.choiceId === choice.id && ch.available)
);
